import {Alert, Container, Stack, Typography} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import {
    AccountPurchasedSmsPackageDto,
    SmsCampaignService,
} from "../../../api/psc";
import {
    DialogContainer, DialogHeader,
    EmptyListMessage,
    EndOfInfiniteListMessage,
    PageHeader,
    Spinner,
} from "../../../components/exports";
import useDynamicList from "../../../hooks/UseDynamicList";
import PurchaseHistoryItem from "../components/PurchaseHistoryItem";
import {useParams, useSearchParams} from "react-router-dom";
import {useDialogContext} from "../../../contexts/DialogueContext";
import {useEffect, useMemo, useState} from "react";

export default function PurchaseHistory() {
    const [params, setParams] = useSearchParams();
    //These two query params are set from server.
    const hasInvoiceRequest = params.get('invrequest');

    const manager = useDynamicList<AccountPurchasedSmsPackageDto>(
        async (offset) => {
            return SmsCampaignService.listPurchasedSmsPackages("1", offset);
        }
    );

    const dialog = useDialogContext();

    useEffect(() => {
        if (hasInvoiceRequest === 'true') {
            dialog.openDialog(
                <>
                    <DialogContainer>
                        <DialogHeader title='خرید موفق'/>
                        <Stack spacing={2} sx={{p: 2}}>
                            <Typography>از خرید شما بسیار سپاسگذاریم.</Typography>
                            <Alert severity='success'>
                                فاکتور شما طی ۲۴ ساعت آینده برای شما ارسال خواهد شد.
                            </Alert>
                        </Stack>
                    </DialogContainer>
                </>
            )
        }
    }, []);

    if (manager.requestInProgress) {
        return <Spinner/>;
    }

    return (
        <Container maxWidth="sm">
            <PageHeader title="لیست خرید های پیامکی"/>

            {manager.empty && (
                <EmptyListMessage message="تاریخچه خرید یافت نشد"/>
            )}

            {manager.hasData && (
                <InfiniteScroll
                    dataLength={manager.totalCount}
                    next={manager.reload}
                    hasMore={manager.hasMore}
                    loader={<Spinner/>}
                    endMessage={<EndOfInfiniteListMessage/>}
                >
                    <Stack spacing={2}>
                        {manager.results.map((p) => {
                            return (
                                <PurchaseHistoryItem
                                    key={p.id}
                                    purchasedItem={p}
                                />
                            );
                        })}
                    </Stack>
                </InfiniteScroll>
            )}
        </Container>
    );
}
